import UserCard from "./UserCard"
import UserCard2 from "./UserCard2"

export default function UsersCatalog({ users }) {

    return (
        <div className="row row-cols-sm-1 row-cols-md-4 g-4">
            {
                users.map(user => (
                    <div className="col-auto" key={user.guid}>
                        <UserCard2
                            user={user} />
                    </div>
                ))
            }
        </div>
    )
}
